import { SharedMixerStateBuffers } from "./shared-state"

interface MixerNodeOptions {
  audioContext: AudioContext
  sharedStateBuffers: SharedMixerStateBuffers
  trackBufferSabs: SharedArrayBuffer[]
}

export class MixerNode {
  static async addModule(audioContext: AudioContext): Promise<void> {
    await audioContext.audioWorklet.addModule(
      new URL("./MixerProcessor.worklet.ts", import.meta.url)
    )
  }

  readonly node: AudioWorkletNode

  constructor({ audioContext, sharedStateBuffers, trackBufferSabs }: MixerNodeOptions) {
    this.node = new AudioWorkletNode(audioContext, "streaming-mixer", {
      numberOfInputs: 0,
      numberOfOutputs: 1,
      outputChannelCount: [2],
      processorOptions: {
        sharedStateBuffers,
        trackBufferSabs,
      },
    })
  }

  connect(destination: AudioNode): void {
    this.node.connect(destination)
  }

  disconnect(): void {
    this.node.disconnect()
  }
}
